import React from "react";
import {
  SkeletonBlock,
  SkeletonAvatar,
  SkeletonText,
  SkeletonStat,
} from "../../../components/Skeleton/Skeleton";

// Loading placeholder shaped like a League Play tile: organizer row, title,
// one line of copy, and the card's own border so the layout doesn't jump when
// the real tile lands. The CTA is not drawn — a grey rectangle where a button
// belongs invites a tap.
export const TileSkeletonCard = () => (
  <div
    aria-hidden="true"
    className="rounded-2xl bg-white border border-gray-200 p-4"
  >
    <div className="flex items-center gap-2.5">
      <SkeletonAvatar size={32} />
      <SkeletonBlock height={10} width="38%" />
    </div>
    <SkeletonBlock height={15} width="66%" className="mt-4" />
    <SkeletonText lines={2} height={10} lastLineWidth="44%" className="mt-3" />
  </div>
);

// Grid of tile skeletons. `cols` mirrors the real grid so the columns match.
const TileSkeleton = ({ count = 1, cols = 1 }) => (
  <div
    aria-busy="true"
    className={`grid gap-3 ${cols === 2 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1"}`}
  >
    {Array.from({ length: count }).map((_, i) => (
      <TileSkeletonCard key={i} />
    ))}
  </div>
);

// Featured-cash placeholder, shaped like the hero card (status pill, title,
// prize block, two stats). The green top edge is drawn grey here — a skeleton
// never carries brand or directional colour.
export const FeaturedCashSkeleton = () => (
  <div
    aria-hidden="true"
    className="rounded-2xl bg-white border border-gray-200 overflow-hidden"
  >
    <SkeletonBlock height={6} rounded="rounded-none" />
    <div className="px-4 pt-4 pb-5 md:px-6 md:pt-5 md:pb-6 flex flex-col items-center">
      <SkeletonBlock height={24} width={112} rounded="rounded-full" />
      <SkeletonBlock height={10} width={148} className="mt-3.5" />
      <SkeletonBlock height={20} width="68%" className="mt-3" />
      <SkeletonBlock height={10} width="44%" className="mt-3" />
      <SkeletonBlock height={62} width="100%" rounded="rounded-xl" className="mt-4" />
      <div className="mt-4 grid grid-cols-2 gap-4 w-full">
        <SkeletonStat align="center" labelWidth={40} valueWidth={56} />
        <SkeletonStat align="center" labelWidth={48} valueWidth={64} />
      </div>
    </div>
  </div>
);

export default TileSkeleton;
